import { render, staticRenderFns } from "./customization.vue?vue&type=template&id=85c48b04&scoped=true"
import script from "./customization.vue?vue&type=script&lang=js"
export * from "./customization.vue?vue&type=script&lang=js"
import style0 from "./customization.vue?vue&type=style&index=0&id=85c48b04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c48b04",
  null
  
)

export default component.exports